import { GridFilterModel } from '@mui/x-data-grid-premium'
import CustomFiltersModal from 'components/DataGrid/components/CustomFiltersModal'
import CustomStatusFilter from 'components/DataGrid/createColumns/CustomStatusFilter'
import {
  ncoStatusFilters,
} from 'components/DataGrid/filterArrays'
import CustomFiltersMenu from 'components/ui/custom-filters-menu-button'
import { Dispatch, SetStateAction } from 'react'

const NcoFilters = ({
  filterModel,
  options,
  value,
  onChangeFilter,
  setterFn,
  isOpen,
  anchorEl,
  onOpenFilters,
  onClose,
  context,
}: {
  filterModel: GridFilterModel
  options: object
  value: string
  onChangeFilter: (fieldName: string, selectedValues: string | string[]) => void
  setterFn: Dispatch<SetStateAction<string>>
  isOpen: boolean
  anchorEl: HTMLElement | null
  onOpenFilters: (event: React.MouseEvent) => void
  onClose: () => void
  context: string
}) => {
  return (
    <>
      <CustomFiltersMenu
        onOpenCustomFilters={onOpenFilters}
        count={filterModel?.items?.length ?? 0}
        badgeColor={'icon.nco'}
      />
      <CustomFiltersModal isOpen={isOpen} anchorEl={anchorEl} handleCloseCustomFilters={onClose}>
        <CustomStatusFilter
          options={options ?? ncoStatusFilters}
          setterFn={setterFn}
          filterModel={filterModel}
          value={value}
          onChange={onChangeFilter}
          context={context ?? 'onboardingStatus'}
        />
      </CustomFiltersModal>
    </>
  )
}
export default NcoFilters
